export default "__VITE_ASSET__CjA53xO2__"